<template>
  <div class="mb-2 col-md-6" v-if="isVisible">
    <el-date-picker
      :value="pending"
      clearable
      type="daterange"
      :placeholder="placeholder"
      @input="onChange"
      :format="dateFormat"
      :value-format="formDateFormat"
      class="w-100"
    >
    </el-date-picker>
  </div>
</template>

<script>
import BaseFilter from "./base-filter";

export default {
  extends: BaseFilter,

  computed: {
    /**
     * @return {String}
     */
    dateFormat() {
      return config('format.element.short.date');
    },

    /**
     * @return {String}
     */
    formDateFormat() {
      return config('format.date');
    },

    /**
     * @return {String}
     */
    value() {
      if (! this.pending) {
        return null;
      }

      let val = _.join(this.pending, ' - ');

      return `${this.labelDisplay}: ${val}`;
    },
  },
}

</script>
